// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qv_a bia_sw bia_kx bia_ky","PostDetailRight__brandDaysPosts":"qv_b bia_sw bia_kx bia_ky"};